// extracted by mini-css-extract-plugin
export default {"wrapper":"newsItem_wrapper__Om6Eb"};